module.exports = __webpack_public_path__ + "static/media/gal0029.c12202ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal00/gal0029.jpg
// module id = 391
// module chunks = 0